import React, { useState } from 'react';
import { ShoppingCartIcon, MenuIcon, XIcon, LogOutIcon, SettingsIcon, UserIcon } from 'lucide-react';
import { useStore } from '../hooks/useStore';
import { DoorStrip, DOOR_PALETTE } from './DoorStrip';
type NavbarProps = {
  onNavigate: (page: string) => void;
  currentPage: string;
  onOpenCart: () => void;
};
export function Navbar({
  onNavigate,
  currentPage,
  onOpenCart
}: NavbarProps) {
  const {
    cartCount,
    isAdmin,
    adminLogout
  } = useStore();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Inicio',
    page: 'home'
  }, {
    name: 'Menú',
    page: 'menu'
  }, {
    name: 'Pedir',
    page: 'order'
  }, {
    name: 'Reservas',
    page: 'reservas'
  }, {
    name: 'Vacantes',
    page: 'vacantes'
  }];
  const adminLinks = [{
    name: 'Pedidos',
    page: 'dashboard'
  }, {
    name: 'Reservas',
    page: 'reservas-dashboard'
  }, {
    name: 'Editor Menú',
    page: 'menu-editor'
  }];
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-stone-100" data-id="element-149">
      <DoorStrip height="h-3" data-id="element-150" />
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between" data-id="element-151">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => onNavigate('home')} data-id="element-152">
          {/* Logo on dark pill so white logo is visible */}
          <div className="bg-[#1a1a1a] rounded-lg px-2 py-1 flex items-center" data-id="element-153">
            <img src="https://cdn.magicpatterns.com/uploads/ewfDCj5QKNDNeQRsTcwjBG/logo_de_Junquito_Gas_(4).ai_(4).png" alt="La Cochera" className="h-7 w-auto" data-id="element-154" />
          </div>
          <span className="hidden sm:block text-sm font-bold tracking-widest text-stone-900 uppercase" data-id="element-155">
            La Cochera
          </span>
        </div>

        <div className="hidden md:flex items-center gap-6" data-id="element-156">
          {navLinks.map((link, i) => {
          const isActive = currentPage === link.page;
          const color = DOOR_PALETTE[i % DOOR_PALETTE.length];
          return <button key={link.page} onClick={() => onNavigate(link.page)} className={`text-sm font-semibold transition-colors relative py-1 ${isActive ? 'text-black' : 'text-stone-400 hover:text-black'}`} data-id="element-157">
                {link.name}
                {isActive && <span className="absolute bottom-0 left-0 right-0 h-0.5 rounded-full" style={{
              backgroundColor: color
            }} data-id="element-158" />}
              </button>;
        })}
        </div>

        <div className="flex items-center gap-2" data-id="element-159">
          {isAdmin ? <div className="relative" data-id="element-160">
              <button onClick={() => setIsAdminMenuOpen(!isAdminMenuOpen)} className={`p-2 rounded-lg transition-colors ${isAdminMenuOpen ? 'bg-black text-white' : 'text-stone-500 hover:bg-stone-100'}`} data-id="element-161">
                <SettingsIcon className="w-5 h-5" data-id="element-162" />
              </button>
              {isAdminMenuOpen && <div className="absolute right-0 top-full mt-2 w-52 bg-white rounded-xl shadow-xl border border-stone-200 p-2 z-50" data-id="element-163">
                  <div className="px-3 py-2 text-[10px] font-bold text-stone-400 uppercase tracking-widest" data-id="element-164">
                    Admin
                  </div>
                  {adminLinks.map(link => <button key={link.page} onClick={() => {
              onNavigate(link.page);
              setIsAdminMenuOpen(false);
            }} className={`w-full text-left px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${currentPage === link.page ? 'bg-black text-white' : 'text-stone-600 hover:bg-stone-50'}`} data-id="element-165">
                      {link.name}
                    </button>)}
                  <div className="h-px bg-stone-100 my-1" data-id="element-166"></div>
                  <button onClick={() => {
              adminLogout();
              onNavigate('home');
              setIsAdminMenuOpen(false);
            }} className="w-full text-left px-3 py-2.5 rounded-lg text-sm font-medium text-red-600 hover:bg-red-50 flex items-center gap-2" data-id="element-167">
                    <LogOutIcon className="w-4 h-4" data-id="element-168" /> Cerrar Sesión
                  </button>
                </div>}
            </div> : <button onClick={() => onNavigate('login')} className="p-2 text-stone-400 hover:text-black hover:bg-stone-100 rounded-lg transition-colors" title="Admin" data-id="element-169">
              <UserIcon className="w-5 h-5" data-id="element-170" />
            </button>}

          <button onClick={onOpenCart} className="relative p-2 text-stone-700 hover:bg-stone-100 rounded-lg transition-colors" data-id="element-171">
            <ShoppingCartIcon className="w-5 h-5" data-id="element-172" />
            {cartCount > 0 && <span className="absolute -top-0.5 -right-0.5 bg-[#be123c] text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center ring-2 ring-white" data-id="element-173">
                {cartCount}
              </span>}
          </button>

          <button className="md:hidden p-2 text-stone-700" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-174">
            {isMobileMenuOpen ? <XIcon className="w-5 h-5" data-id="element-175" /> : <MenuIcon className="w-5 h-5" data-id="element-176" />}
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white border-b border-stone-100 p-3 flex flex-col gap-1 z-40" data-id="element-177">
          {navLinks.map((link, i) => {
        const isActive = currentPage === link.page;
        const color = DOOR_PALETTE[i % DOOR_PALETTE.length];
        return <button key={link.page} onClick={() => {
          onNavigate(link.page);
          setIsMobileMenuOpen(false);
        }} className={`text-left py-3 px-4 rounded-lg font-semibold text-sm transition-colors ${isActive ? 'text-white' : 'text-stone-600 hover:bg-stone-50'}`} style={isActive ? {
          backgroundColor: color
        } : {}} data-id="element-178">
                {link.name}
              </button>;
      })}
          {isAdmin && <>
              <div className="h-px bg-stone-100 my-2" data-id="element-179"></div>
              <div className="px-4 py-1 text-[10px] font-bold text-stone-400 uppercase tracking-widest" data-id="element-180">
                Admin
              </div>
              {adminLinks.map(link => <button key={link.page} onClick={() => {
          onNavigate(link.page);
          setIsMobileMenuOpen(false);
        }} className="text-left py-2.5 px-4 rounded-lg text-sm text-stone-500 hover:bg-stone-50" data-id="element-181">
                  {link.name}
                </button>)}
            </>}
        </div>}
    </header>;
}